import type { UiBadgeVariant } from "@/components/ui/elements/badge/UiBadge";

/** 2026-11 からの全特典廃止で、サーバーが付けても表示しない求人タグ */
const HIDDEN_JOB_OFFER_TAGS = new Set(["特典あり"]);

/** 表示しないタグか */
export function isHiddenJobOfferTag(tag: string): boolean {
  return HIDDEN_JOB_OFFER_TAGS.has(tag);
}

/** 表示しないタグを除く。タグ欄の枠を出すかは、除いた後の件数で判定する */
export function omitHiddenJobOfferTags(tags: readonly string[]): string[] {
  return tags.filter((tag) => !isHiddenJobOfferTag(tag));
}

/** 求人タグ文字列からバッジバリアントを推定する */
export function getJobOfferTagBadgeVariant(tag: string): UiBadgeVariant {
  if (tag === "限定オファー") return "action";
  if (tag === "連動勤務") return "action";
  if (tag === "特典あり") return "warning";
  if (tag === "夜勤") return "info";
  if (tag === "即日") return "warning";
  if (tag.includes("終了") || tag.includes("アーカイブ")) return "gray";
  return "teal";
}

/** 求人カテゴリ名からバッジバリアントを推定する */
export function getJobOfferCategoryBadgeVariant(
  categoryName: string,
): UiBadgeVariant {
  if (categoryName === "夜勤") return "info";
  return "teal";
}
